import { render, staticRenderFns } from "./nice-value.vue?vue&type=template&id=e12aaa92&scoped=true"
import script from "./nice-value.vue?vue&type=script&lang=js"
export * from "./nice-value.vue?vue&type=script&lang=js"
import style0 from "./nice-value.vue?vue&type=style&index=0&id=e12aaa92&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12aaa92",
  null
  
)

export default component.exports